import { Component, inject, Input } from '@angular/core';
import { LnFooterComponent } from '@components/ln-footer/ln-footer.component';

import { LnTopBannerSearchMenuComponent } from '@components/ln-top-banner-search-menu/ln-top-banner-search-menu.component';
import { MenuActions } from '../../states/menu_actions';

@Component({
  selector: 'ln-ln-pages-armor',
  imports: [LnFooterComponent, LnTopBannerSearchMenuComponent],
  templateUrl: './ln-pages-armor.component.html',
  styleUrl: './ln-pages-armor.component.css',
})
export class LnPagesArmorComponent {
  private menuActions = inject(MenuActions);
  @Input() showFooter = true;
  GoHome() {
    this.menuActions.goHome();
  }
}
